// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';
import {AddressElement, AddressElements} from './address-element';
import {KeyValueList} from '../key-value-list';

export const customerAddressFieldKeys = {
    ADDRESS_COMPONENT: 'addressComponent',
    COUNTRY: 'countryCode',
    ADDRESS_LINE_1: 'addressLine1',
    ADDRESS_LINE_2: 'addressLine2',
    CITY: 'city',
    STATE_REGION: 'stateCode',
    ZIP_POSTAL_CODE: 'postalCode'
};

export const AddressComponent = t.struct({
    addressElements: AddressElements,
    cityAsDropdown: t.Boolean,
    cities: t.list(t.String),
    states: KeyValueList,
    useTaxId: t.Boolean
}, {
    defaultProps: {
        addressElements: {
            [customerAddressFieldKeys.ADDRESS_LINE_1]: new AddressElement({}),
            [customerAddressFieldKeys.ADDRESS_LINE_2]: new AddressElement({}),
            [customerAddressFieldKeys.CITY]: new AddressElement({}),
            [customerAddressFieldKeys.STATE_REGION]: new AddressElement({}),
            [customerAddressFieldKeys.ZIP_POSTAL_CODE]: new AddressElement({})
        },
        cities: [],
        cityAsDropdown: false,
        states: [],
        useTaxId: false
    },
    name: 'AddressComponent',
    strict: true
});

AddressComponent.prototype.getLabelValueList = function () {
    return this.states.map((item) => ({
        label: item.value,
        value: item.key
    }));
};

AddressComponent.prototype.getCityLabelValueList = function () {
    return this.cities.map((item) => ({
        label: item,
        value: item
    }));
};
